// ----------------------------------------------------------------------


// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const fr = {
  demo: {
    title: `France`,
    introduction: `Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte. Il n'a pas fait que survivre cinq siècles, mais s'est aussi adapté à la bureautique informatique, sans que son contenu n'en soit modifié. Il a été popularisé dans les années 1960 grâce à la vente de feuilles Letraset contenant des passages du Lorem Ipsum, et, plus récemment, par son inclusion dans des applications de mise en page de texte, comme Aldus PageMaker.`,
  },
  docs: {
    hi: `Bonjour`,
    description: `Besoin d'aide? \n Consultez notre documentation.`,
    documentation: `documentation`,
  },
  nav: {
    dashboard: "Tableau de bord",
    management: "La gestion",
    organizations: "Toutes les organisations",
    sub_organizations: "Sous-organisations",
    staff: "Personnel",
    users: "Utilisateurs",
    operational: "Opérationnel",
    analytics: "Système analytique",
    app_admins: "Admins de l'application",
    products: "Produits",
    commands: "Commandes",
    categories: "Catégories",
    statistics: "Statistiques",
    settings: "Paramètres",
    billing: "Facturation",
    parent_organization: "Organisation Parente",
    my_sub_organization: "Ma Sous-Organisation",
    branch_settings: "Paramètres de l'agence",
    general: "Dashboard",
    parent_staff: "Le staff de l'organisation parent",
    Pos_config: "Configuration POS",
    create_user: "Créer un utilisateur",
    create_product: "Créer un produit",
    products_from_pos: "Les produits de POS",
    order_products: "Les produits",
    sub_org_products_list: "Liste des produits de la sous-organisation",
    sub_org_staff_list: "Liste de staff de la sous-organisation",
    all_organizations: "Organisations",
    sub_organizations_list: "Sous organisations",
    new_organization: "Organisation",
    new_sub_organization: "Sous-organisation",
    new_category: "Catégorie",
    edit_category: "Modifier la catégorie",
    organization: "Organisation",
    list: "Liste",
    childs_organization: "Organisations filles",
    save_changes: "Enregistrer les modifications",
    create_organization: "Créer une organisation",
    edit_organization: "Modifier l'organisation",
    new_parent_organization: "Organisation",
    cancel: "Annuler",
    back: "Retour",
    go_to_settings: "Aller aux paramètres",
    company_settings: "Paramètres Entreprise",
    action_logs: "Journal d'activité",
    upselling: "Upselling",
    overview: "Vue d'ensemble",
    new_badge: "NOUVEAU",
    health: {
      system_name: "Système AI-LYN",

      all_systems: "Tous les systèmes sont",
      operational: "opérationnels",
      maintenance: "en maintenance",
      system_status: "État du système",
      aws_server: "Serveur AWS",
      voice_app: "App vocale",
      online: "En ligne",
      offline: "Hors ligne",
      pos_connected: "POS connecté",
      pos_error: "POS en erreur",
      pos_syncing: "POS synchro…",
      pos_not_configured: "POS non connecté",
      pos_unknown: "POS indisponible",
    },
  },
  org: {
    name: "Nom de l'organisation",
    monthly_fee: "Frais mensuels ($)",
    order_fee: "Frais par commande ($)",
    payment_deadline: "Délai de paiement (jours)",
    postal_code: "Code postal",
    postal_code_ex: "Code postal (ex: H2W)",
    city: "Ville",
    province: "Province",
    federal_tax: "Taxe fédérale (%)",
    provincial_tax: "Taxe provinciale (%)",
    info: "Informations de l'organisation",
    info_title: "Informations de l'organisation",
    manager_info: "Informations du gestionnaire",
    manager_info_title: "Informations du gestionnaire",
    taxes_section: "Taxes (remplies automatiquement par le code postal)",
    manager_name: "Nom du gestionnaire",
    manager_phone: "Téléphone du gestionnaire",
    manager_email: "Email du gestionnaire",
    password: "Mot de passe",
    description: "Description",
    branches_number: "Succursales",
    details: "Détails de l'organisation",
    sub_details: "Détails de la sous-organisation",
    create: "Créer une organisation",
    edit_org: "Modifier l'organisation",
    create_success: "Création réussie !",
    update_success: "Mise à jour réussie !",
    create_fail: "Échec de la création",
    update_fail: "Échec de la mise à jour",
    error: "Une erreur est survenue",
    tax_update_info: "Localisation et taxes mises à jour !",
    agent_first_name: "Prénom de l'agent",
    agent_last_name: "Nom de l'agent",
    agent_email: "Email de l'agent",
    agent_phone: "Téléphone de l'agent",
    support_account: "Compte Support",
    support_name: "Nom du support",
    support_phone: "Téléphone du support",
    support_email: "Email du support",
    support_password: "Mot de passe du support",
  },
  order: {
    list: "Commandes",
    total: "Total commande",
    date: "Date commande",
    status: "Statut",
    details: "Détails",
    delete: "Supprimer",
    edit: "Modifier",
    confirm: "Confirmer",
    delete_title: "Suppression de commande",
    delete_confirm: "Êtes-vous sûr de vouloir supprimer cette commande ?",
    delete_multiple: "Êtes-vous sûr de vouloir supprimer",
    items: "commandes ?",
    all: "Tous",
    id: "ID Commande",
    waiting: "En attente",
    accepted: "Accepté",
    unaccepted: "Non accepté",
    on_the_move: "En cours",
    delivered: "Livré",
    undelivered: "Non livré",
    cancelled: "Annulée",
    pos_entered: "Configurer POS",
    in_progress: "En cours",
    subtotal: "Sous-total",
    tax_fed: "TPS",
    tax_prov: "TVQ",
    items_count: "{{count}} article",
    items_count_plural: "{{count}} articles",
    products_count: "{{count}} produit",
    products_count_plural: "{{count}} produits",
    products_list: "Produits commandés",
    qty_short: "Qté",
    price_short: "Prix",
    extras: "Extras",
    no_orders: "Aucune commande trouvée",
    no_orders_subtitle: "Les nouvelles commandes apparaîtront automatiquement",
    auto_update: "Mise à jour automatique",
    accuracy: "Précision",
  },
  organization: {
    listTitle: "Liste des organisations",
    new: "Organisation",
    name: "Nom",
    responsibleName: "Nom du responsable",
    responsiblePhone: "Téléphone du responsable",
    address: "Adresse",
    numberOfBranches: "Succursales",
    search_placeholder: "Rechercher (nom, ville, email...)",
    advanced_filters: "Filtres avancés",
    filters: {
      all: "Toutes",
      active: "Actives",
      banned: "Bannies",
      inactive: "Inactives",
    }
  },
  product: {
    name: "Produit",
    price: "Prix",
    category: "Catégorie",
    status: "Statut",
    search: "Rechercher...",
    clear: "Effacer",
  },
  filters: {
    all: "Tous",
    active: "Actifs",
    banned: "Bannis",
    inactive: "Inactifs",
  },
  table: {
    name: "Nom",
    manager_name: "Nom du responsable",
    manager_phone: "Téléphone du responsable",
    manager_email: "Email du responsable",
    city: "Ville",
    status: "Statut",
    branches_number: "Succursales",
    orders_30d: "Commandes IA (30j)",
    performance: "Performance",
    actions: "Actions",
    full_name: "Nom complet",
    phone: "Téléphone",
    email: "Email",
    role: "Rôle",
    monthly_fee: "Frais mensuels",
    order_fee: "Frais par commande",
  },
  actions: {
    Delete: "Supprimer",
    Edit: "Modifier",
    Details: "Détails",
    Admin: "Admin",
    Branches: "Agences",
    Confirm: "Confirmer",
    Cancel: "Annuler",
    Loading: "Chargement...",
    Active: "Actif",
    Inactive: "Inactif",
    Close: "Fermer",
  },
  common: {
    optional: "facultatif",
  },
  upload: {
    allowed: "Autorisé *.jpeg, *.jpg, *.png, *.gif",
    max_size: "taille maximale de",
    title: "Déposez ou sélectionnez un fichier",
    description_before: "Déposez les fichiers ici ou",
    browse: "parcourir",
    description_after: "depuis votre appareil",
    remove_all: "Tout retirer",
    upload_files: "Téléverser les fichiers",
  },
  status_options: {
    prospecting: "Prospection",
    interested_in: "Intéressé",
    negotiation: "Négociation",
    confirmed: "Confirmé",
    deployment_in_progress: "Déploiement en cours",
    active: "Actif",
    on_hold: "En attente",
    to_follow_up: "À relancer",
    closed: "Fermé",
    declined: "Refusé",
  },
  dialogs: {
    organization_deletion: "Suppression d'organisation",
    organization_deletion_confirmation: "Êtes-vous sûr de vouloir supprimer cette organisation ?",
    organization_user_deletion: "Suppression d'utilisateur",
    organization_user_deletion_confirmation: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    sub_organization_deletion: "Suppression de sous-organisation",
    confirm_deletion: "Êtes-vous sûr de vouloir supprimer ?",
    branch_user_deletion: "Suppression d'utilisateur d'agence",
    branch_user_deletion_confirmation: "Êtes-vous sûr de vouloir supprimer cet utilisateur d'agence ?",
    order_deletion: "Suppression de commande",
    order_deletion_confirmation: "Êtes-vous sûr de vouloir supprimer cette commande ?",
    product_deletion: "Suppression de produit",
    product_deletion_confirmation: "Êtes-vous sûr de vouloir supprimer ce produit ?",
  },
  app: `application`,
  user: `utilisateur`,
  list: `liste`,
  edit: `éditer`,
  shop: `boutique`,
  blog: `blog`,
  post: `poste`,
  mail: `e-mail`,
  chat: `discuter`,
  cards: `cartes`,
  posts: `des postes`,
  create: `créer`,
  kanban: `kanban`,
  general: `général`,
  banking: `bancaire`,
  booking: `réservation`,
  profile: `profil`,
  account: `compte`,
  details: `détail`,
  personal_information: `Informations personnelles`,
  created_at: `Créé le`,
  updated_at: `Mis à jour le`,
  user_details: `Détail de staff`,
  api: `API`,
  free: `Gratuit`,
  placeholders: {
    pos_key: "Clé POS...",
    fees: "Frais...",
    monthly: "Mensuel...",
    order: "Commande...",
    share: "Partagez ce que vous pensez ici...",
  },
  checkout: `vérifier`,
  calendar: `calendrier`,
  analytics: `analytique`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `niveau menu`,
  menu_level_2a: `niveau menu 2a`,
  menu_level_2b: `niveau menu 2b`,
  menu_level_3a: `niveau menu 3a`,
  menu_level_3b: `niveau menu 3b`,
  menu_level_4a: `niveau menu 4a`,
  menu_level_4b: `niveau menu 4b`,
  item_disabled: `élément désactivé`,
  item_label: `étiquette de l'article`,
  item_caption: `légende de l'article`,
  item_external_link: `lien externe de l'article`,
  description: `la description`,
  other_cases: `autres cas`,
  item_by_roles: `élément par rôles`,
  only_admin_can_see_this_item: `seul l'administrateur peut voir cet élément`,
  auth: {
    invalid_code: "Le code de vérification est invalide. Veuillez vérifier et réessayer.",
    code_expired: "Le code de vérification a expiré. Veuillez en demander un nouveau.",
    email_not_found: "Aucun compte trouvé avec cette adresse email.",
    email_send_failed: "Échec de l'envoi de l'email. Veuillez réessayer plus tard.",
    password_changed: "Mot de passe changé avec succès !",
    code_resent: "Code de vérification envoyé avec succès !",
    email_required: "L'email est requis pour renvoyer le code.",
    generic_error: "Une erreur inattendue est survenue. Veuillez réessayer.",
    code_required: "Code requis",
    email_is_required: "Email requis",
    email_valid: "L'email doit être une adresse email valide",
    password_required: "Mot de passe requis",
    first_name_required: "Prénom requis",
    last_name_required: "Nom requis",
    confirm_password_required: "Confirmation du mot de passe requise",
    passwords_must_match: "Les mots de passe doivent correspondre",
    password_min_length: "Le mot de passe doit contenir au moins 6 caractères",
    forgot_password: "Mot de passe oublié ?",
    login: "Connexion",
    create_account: "Créer un compte",
    verify: "Vérifier",
    verify_success: "Vérification réussie !",
    update_password: "Mettre à jour le mot de passe",
    resend_code: "Renvoyer le code",
    dont_have_code: "Vous n'avez pas de code ?",
  },
  invoice: {
    title: "Factures",
    list: "Historique des factures",
    status_in_progress: "En cours",
    status_to_pay: "À payer",
    status_paid: "Payée",
    status_late: "En retard",
    total_orders: "Nb Commandes",
    total_amount: "Montant Total",
    month: "Mois",
    year: "Année",
    download_pdf: "Télécharger PDF",
    pay: "Payer la facture",
    upload_proof: "Uploader preuve de paiement",
    upload_proof_required: "Veuillez sélectionner un fichier",
    proof_file: "Fichier preuve",
    payment_type: "Type de paiement",
    payment_type_transfer: "Virement",
    payment_type_check: "Chèque",
    payment_type_required: "Veuillez sélectionner le type de paiement",
    confirm_payment: "Confirmer le paiement",
    payment_success: "Paiement confirmé — statut mis à jour",
    proof_reference_placeholder: "N° de virement / chèque...",
    payment_date: "Date de paiement",
    proof_reference: "Référence preuve",
    id: "ID Facture",
    no_invoices: "Aucune facture trouvée",
    all: "Toutes",
    delete_confirmation: "Êtes-vous sûr de vouloir supprimer cette facture ?",
    deadline_p7: "P7 - Paiement à 7 jours",
    deadline_p15: "P15 - Paiement à 15 jours",
    deadline_p30: "P30 - Paiement à 30 jours",
    deadline_p45: "P45 - Paiement à 45 jours",
    deadline_p60: "P60 - Paiement à 60 jours",
    view_pdf: "Aperçu",
    preview: "Aperçu de la facture",
  },
  pos: {
    config_title: "Configuration Point de Vente (POS)",
    config_description: "Configurez ici la connexion spécifique à votre branche. Si aucun paramètre n'est renseigné, la configuration de l'organisation parente sera utilisée par défaut.",
    type: "Type de POS",
    sync_with_pos: "Synchroniser avec POS",
    pull: "Récupérer depuis POS",
    push: "Envoyer vers POS",
    retrieve_from_pos: "Récupérer depuis POS",
    send_to_pos: "Envoyer vers POS",
    save_config: "Enregistrer la configuration",
    fill_required_fields: "Veuillez remplir tous les champs obligatoires",
    loading_fields: "Chargement des champs de configuration...",
    status: {
      not_configured: "Non configuré",
      configured: "Configuré (Prêt à synchroniser)",
      syncing: "Synchronisation en cours...",
      synced: "Synchronisé",
      error: "Erreur de synchronisation",
    },
    save_success: "Configuration POS sauvegardée avec succès",
    save_error: "Erreur lors de la sauvegarde configuration POS",
    sync_success: "Synchronisation bidirectionnelle réussie !",
    sync_error: "Erreur lors de la synchronisation",
    pull_success: "Récupération depuis le POS réussie !",
    pull_error: "Erreur lors de la récupération depuis le POS",
    pull_loading: "Récupération des produits depuis le POS...",
    push_success: "Envoi vers le POS réussi !",
    push_error: "Erreur lors de l'envoi vers le POS",
    push_loading: "Envoi des produits vers le POS...",
    save_loading: "Sauvegarde et synchronisation initiale...",
    not_configured_title: "POS non configuré",
    not_configured_content: "Vous devez configurer le POS dans les paramètres de la succursale avant de pouvoir synchroniser les produits.",
  },
  upsell: {
    title: "Upselling",
    description: "Gérez les suggestions d'addons, de produits et les remplacements intelligents.",
    new_rule: "Règle",
    tabs: {
      overview: "Vue d'ensemble",
      rules: "Toutes les règles",
      addons: "Addons",
      end_order: "Fin de commande",
      analytics: "Analytics",
    },
    kpi: {
      acceptance_rate: "Taux d'acceptation",
      revenue: "Revenus générés",
      suggestions: "Suggestions envoyées",
      boost: "Panier moyen boosté",
      vs_previous: "vs période précédente",
    },
    chart: {
      title: "Performance des upsells",
      subtitle: "Taux d'acceptation vs Revenus générés",
      "30_days": "30 derniers jours",
      "7_days": "7 derniers jours",
      export: "Exporter",
    },
    list: {
      title: "Règles d'upselling",
      search: "Rechercher une règle...",
      empty: "Aucune règle configurée.",
      add: "Ajouter une règle",
      all_products: "Tous les produits",
      select_help: "Sélectionnez une règle pour voir les détails ou cliquez sur \"Nouvelle règle\"",
    },
    form: {
      details: "Détails de la règle",
      active: "Actif",
      rule_type: "Type de règle",
      types: {
        addon: "Addon",
        product: "Produit suggéré",
        suggested_product: "Produit suggéré",
        replacement: "Remplacement",
        end_order: "Fin de commande",
      },
      trigger: "Déclencheur",
      trigger_product: "Produit déclencheur",
      suggest: "Proposer",
      suggested_product: "Produit suggéré",
      custom_phrase_help: "Phrase personnalisée pour Gemini (ex: \"Souhaitez-vous du fromage ?\"). Si vide, une phrase générique sera utilisée.",
      moment: "Moment",
      conditions: "Conditions (optionnel)",
      add_condition: "Ajouter",
      time: "Heure",
      channel: "Canal",
      priority: "Priorité",
      delete: "Supprimer",
      save: "Enregistrer",
    },
    moments: {
      after_add_item: "Après l'ajout",
      before_payment: "Avant le paiement",
      end_of_order: "Fin de commande",
      anytime: "N'importe quand",
    },
    priority: {
      high: "Haute",
      medium: "Moyenne",
      low: "Basse",
    }
  },
  operational_kpi: {
    page_title: "Tableau de bord opérationnel",
    heading: "Tableau de bord opérationnel",
    subtitle: "Suivi en temps réel des performances de l'IA et des bornes connectées.",
    online: "EN LIGNE",
    offline: "HORS LIGNE",
    period: "Période",
    period_24h: "Dernières 24h",
    period_7d: "7 derniers jours",
    period_30d: "30 derniers jours",
    branch: "Succursale",
    refresh: "Actualisation",
    refresh_off: "Désactivée",
    refresh_now: "Actualiser",
    section_realtime: "Temps réel",
    live_data: "Données en direct",
    section_ai_performance: "Performance IA",
    section_monitoring: "Monitoring & qualité",
    ai_health_score: "Score de santé IA",
    active_terminals: "Bornes actives",
    terminals_online_now_suffix: "en ligne actuellement",
    active_sessions: "Sessions en cours",
    in_progress: "En cours",
    completed_sessions: "Sessions complétées",
    abandoned_sessions_prefix: "Sessions abandonnées :",
    clients_served: "Clients servis",
    orders_delivered: "Commandes livrées",
    ai_requests: "Requêtes IA",
    over_period: "Sur la période",
    wait_time: "Temps d'attente",
    avg_in_queue: "Moyenne en file",
    pickup_time: "Temps de prise",
    average: "Moyenne",
    order_duration: "Durée commande",
    recognition_success: "Reconnaissance réussie",
    orders_no_error: "Commandes sans erreur",
    prediction_reliability: "Fiabilité prédiction",
    confidence_score: "Score de confiance",
    human_interventions: "Interventions humaines",
    today: "Aujourd'hui",
    repeat_count: "Nombre de redites",
    alerts_triggered: "Alertes déclenchées",
    problems_detected: "Problèmes détectés",
    avg_latency: "Latence moyenne",
    p95_latency: "Latence P95",
    orders_per_hour: "Commandes par heure",
    hour: "Heure",
    load_per_day: "Charge (volume par jour)",
    load_per_5min: "Charge (volume par tranche de 5 min)",
    no_recent_load: "Pas de données de charge récentes.",
    total: "Total",
    avg_per_day: "Moyenne / jour",
    peak: "Pic",
    realtime_orders: "Commandes en temps réel",
    view_all: "Voir toutes",
    col_number: "N°",
    col_state: "État",
    col_time: "Heure",
    col_volume: "Volume",
    col_ai: "IA",
    no_recent_orders: "Aucune commande récente dans la fenêtre sélectionnée.",
  },
  analytics_kpi: {
    page_title: "Tableau de bord Analytics",
    heading: "Indicateurs Analytics",
    subtitle: "Analyses de conversion et tendances métier de la commande vocale IA.",
    window: "Période",
    window_24h: "Dernières 24h",
    window_7d: "7 derniers jours",
    window_30d: "30 derniers jours",
    branch_scope: "Succursale",
    refresh: "Actualisation",
    refresh_off: "Désactivée",
    refresh_now: "Actualiser",
    ai_orders_trend: "Commandes IA (somme tendance)",
    completion_rate: "Taux de complétion",
    avg_latency_trend: "Latence moyenne (tendance)",
    alerts_trend: "Alertes (somme tendance)",
    drop_off_rate: "Taux d'abandon",
    human_takeover_rate: "Taux d'intervention humaine",
    daily_trends: "Tendances quotidiennes",
    daily_trends_sub: "Commandes, conversion et abandon dans le temps",
    col_day: "Jour",
    col_ai_orders: "Commandes IA",
    col_avg_latency: "Latence moy.",
    col_alerts: "Alertes",
    no_data: "Aucune donnée de tendance pour la période sélectionnée.",
  },
  action_logs: {
    page_title: "Journal d'activité",
    heading: "Journal d'activité",
    breadcrumb_logs: "Journaux",
    filter_action_type: "Type d'action",
    filter_entity: "Entité (ex: Organisation)",
    filter_all: "Tous",
    col_date: "Date",
    col_user: "Utilisateur",
    col_action: "Action",
    col_entity: "Entité",
    col_organization: "Organisation",
    col_description: "Description",
    col_ip: "IP",
    col_actions: "Actions",
    detail_title: "Détails du journal d'activité",
    detail_user: "Utilisateur",
    detail_email: "Email",
    detail_role: "Rôle",
    detail_action: "Action",
    detail_entity: "Entité",
    detail_entity_id: "ID de l'entité",
    detail_description: "Description",
    detail_details: "Détails (JSON)",
    detail_ip: "Adresse IP",
    detail_organization: "Organisation",
    detail_date: "Date",
    delete_title: "Supprimer le journal",
    delete_confirm: "Êtes-vous sûr de vouloir supprimer ce journal d'activité ?",
    no_details: "Aucun détail supplémentaire",
    no_organization: "N/A",
    delete_success: "Journal d'activité supprimé avec succès",
    delete_error: "Erreur lors de la suppression du journal d'activité",
  },
  pages: {
    users_management: "Gestion Globale des Utilisateurs",
    all_users_list: "Liste de tous les utilisateurs",
    user_cards: "Cartes d'utilisateurs",
    account: "Compte",
    account_settings: "Paramètres du compte",
    edit_staff: "Modifier un staff",
    edit_product: "Modifier produit",
    org_product_details: "Détails du produit de l'organisation",
    create_product: "Créer nouveau produit",
    permission_denied: "Permission refusée",
    parent_org_profile: "Profil de l'organisation parente",
    sub_organizations: "Les sous-organisations",
    edit_sub_org: "Modifier la sous-organisation",
    sub_org_profile: "Profil de la sous-organisation",
    create_sub_org: "Créer une sous-organisation",
    parent_organization: "Organisation Parente",
    create_order: "Créer une nouvelle commande",
    order_details: "Détails de la commande",
    kanban: "Kanban",
    edit_invoice: "Modifier la facture",
    invoice_details: "Détails de la facture",
    create_invoice: "Créer une nouvelle facture",
    file_manager: "Gestionnaire de fichiers",
    shop: "Boutique",
    product_details: "Détails du produit",
    checkout: "Passer commande",
    calendar: "Calendrier",
    post_details: "Détails de l'article",
    blog: "Blog",
    create_post: "Créer un nouvel article",
  },
};

export default fr;
